import topic from '../topic';
export const custAPI = {
  getCusts: topic.custTopic + '/get_custs',
  getCustById: topic.custTopic + '/get_cust_by_id',
  addCust: topic.custTopic + '/add_cust',
  editCust: topic.custTopic + '/edit_cust',
  deleteCustByIds: topic.custTopic + '/delete_cust_by_ids',
  getAllCustsV1: topic.custTopic + '/get_all_custs_v1'
};
